import {
  AddAssetsDebtsIcon,
  CheckCircleIcon,
  ChevronDownIcon,
  ConsentOrderIcon,
  DocumentSignIcon,
  EditIcon,
  FinalDetailsIcon,
  InitialDetailsIcon,
  LawyerConsultationIcon
} from "@fla/components";
import { AssetDebtFields, AssetsDebts, ConsentOrdersPathName, InitialDetails } from "@fla/components/src/interfaces";
import classNames from "classnames";
import { Link } from "react-router-dom";

export const consentOrderRoutes: {
  name: string;
  basePath?: string;
  path: ConsentOrdersPathName;
  match: ConsentOrdersPathName[];
  children?: { name: string; step: number }[];
  subRoutes?: { name: string; path: ConsentOrdersPathName; field: keyof AssetDebtFields }[];
}[] = [
  {
    name: "Welcome",
    path: ConsentOrdersPathName.Welcome,
    match: [ConsentOrdersPathName.Welcome]
  },
  {
    name: "Initial Details",
    basePath: "initial-details",
    path: ConsentOrdersPathName.InitialDetails,
    match: [ConsentOrdersPathName.InitialDetails],
    children: [
      {
        name: "Your Details",
        step: 1
      },
      {
        name: "Former Partner Details",
        step: 2
      },
      {
        name: "Relationship",
        step: 3
      },
      {
        name: "Children",
        step: 4
      },
      {
        name: "Children's Living Arrangements",
        step: 5
      },
      {
        name: "Your Income",
        step: 6
      },
      {
        name: "Partner's Income",
        step: 7
      },
      {
        name: "Financial Information",
        step: 8
      },
      {
        name: "Financial Contributions",
        step: 9
      },
      {
        name: "Parenting & Homemaker",
        step: 10
      },
      {
        name: "Non Financial Contribution",
        step: 11
      },
      {
        name: "Additional Financial Contributions",
        step: 12
      },
      {
        name: "Future Needs",
        step: 13
      },
      {
        name: "Financial Resources",
        step: 14
      },
      {
        name: "Confirmation",
        step: 15
      }
    ]
  },
  {
    name: "Assets & Debts",
    basePath: "assets-debts",
    path: ConsentOrdersPathName.RealEstate,
    match: [ConsentOrdersPathName.RealEstate],
    subRoutes: [
      {
        name: "Real Estate",
        path: ConsentOrdersPathName.RealEstate,
        field: "real_estate"
      },
      {
        name: "Superannuation",
        path: ConsentOrdersPathName.Superannuation,
        field: "super"
      },
      {
        name: "Bank",
        path: ConsentOrdersPathName.Bank,
        field: "bank"
      },
      {
        name: "Vehicle",
        path: ConsentOrdersPathName.Vehicle,
        field: "vehicle"
      },
      {
        name: "Investments",
        path: ConsentOrdersPathName.Investments,
        field: "investments"
      },
      {
        name: "Business",
        path: ConsentOrdersPathName.Business,
        field: "business"
      },

      {
        name: "Overseas Assets",
        path: ConsentOrdersPathName.Overseas,
        field: "overseas"
      },
      {
        name: "Furniture & Personal Effects",
        path: ConsentOrdersPathName.Furniture,
        field: "furniture"
      },
      {
        name: "Debts",
        path: ConsentOrdersPathName.Debts,
        field: "debts"
      },
      {
        name: "Additional Requirements",
        path: ConsentOrdersPathName.AdditionalRequirements,
        field: "additional_requirements"
      },
      {
        name: "Summary",
        path: ConsentOrdersPathName.Summary,
        field: "summary"
      }
    ]
  },
  {
    name: "Submit",
    path: ConsentOrdersPathName.Submit,
    match: [ConsentOrdersPathName.Submit]
  }
];

export const initialDetailsRoutes = [
  {
    name: "Your Details",
    step: 1
  },
  {
    name: "Former Partner's Details",
    step: 2
  },
  {
    name: "Relationship Details",
    step: 3
  },
  {
    name: "Children",
    step: 4
  },
  {
    name: "Children's Living Arrangements",
    step: 5
  },
  {
    name: "Your Current Income",
    step: 6
  },
  {
    name: "Former Partner’s Current Income",
    step: 7
  },

  {
    name: "Financial Contributions",
    step: 9
  },
  {
    name: "Parenting and Homemaker Contributions",
    step: 10
  },
  {
    name: "Non-Financial Contributions",
    step: 11
  },
  {
    name: "Additional Financial Contributions",
    step: 12
  },
  {
    name: "Future Needs",
    step: 13
  },
  {
    name: "Financial Resources",
    step: 14
  }
];

export const assetsDebtsRoutes: { name: string; path: ConsentOrdersPathName; field: keyof AssetDebtFields }[] = [
  {
    name: "Real Estate",
    path: ConsentOrdersPathName.RealEstate,
    field: "real_estate"
  },
  {
    name: "Superannuation",
    path: ConsentOrdersPathName.Superannuation,
    field: "super"
  },
  {
    name: "Bank",
    path: ConsentOrdersPathName.Bank,
    field: "bank"
  },
  {
    name: "Vehicle",
    path: ConsentOrdersPathName.Vehicle,
    field: "vehicle"
  },
  {
    name: "Investments",
    path: ConsentOrdersPathName.Investments,
    field: "investments"
  },
  {
    name: "Business",
    path: ConsentOrdersPathName.Business,
    field: "business"
  },

  {
    name: "Overseas Assets",
    path: ConsentOrdersPathName.Overseas,
    field: "overseas"
  },
  {
    name: "Furniture & Personal Effects",
    path: ConsentOrdersPathName.Furniture,
    field: "furniture"
  },
  {
    name: "Debts",
    path: ConsentOrdersPathName.Debts,
    field: "debts"
  },
  {
    name: "Additional Requirements",
    path: ConsentOrdersPathName.AdditionalRequirements,
    field: "additional_requirements"
  },
  {
    name: "Summary",
    path: ConsentOrdersPathName.Summary,
    field: "summary"
  }
];

export const steps = ({
  consentOrders,
  openAccordions,
  toggleAccordion
}: {
  consentOrders: {
    assetsDebts: AssetsDebts;
    initialDetails: InitialDetails;
    submitted: boolean;
    uid: string;
  };
  openAccordions: any;
  toggleAccordion: any;
}) => {
  return [
    {
      icon: InitialDetailsIcon,
      label: "PART 1",
      title: "Initial Details",
      description:
        "Here you will answer some short questions about yourself and your former partner. There will also be some required details about the relationship and surrounding dates.",
      link: "",
      showMore: true,
      showMoreContent: () => {
        const isSubmitted = consentOrders?.submitted ?? false;
        const isCompleted = (step: number) =>
          consentOrders?.initialDetails
            ? Array(
                consentOrders?.initialDetails?.isCompleted
                  ? consentOrders?.initialDetails?.currentStep
                  : consentOrders?.initialDetails?.currentStep - 1
              )
                .fill({})
                .map((_, i) => i + 1)
                .includes(step)
            : false;
        const isNext = (step: number) => {
          return consentOrders?.initialDetails?.currentStep === undefined && step === 1
            ? true
            : consentOrders?.initialDetails?.currentStep === step;
        };
        const isOpen = openAccordions[0];

        return (
          <div>
            {isOpen ? (
              <div className="space-y-5 mt-5 md:mt-0">
                {initialDetailsRoutes.map((data, idx) => (
                  <div key={+idx} className="w-full flex items-center bg-[#f2f2f2] rounded-lg p-3 md:p-5">
                    <div className="w-10">
                      {isCompleted(data.step) ? (
                        <CheckCircleIcon
                          strokeColor="text-[#2F9D5E]"
                          classes="w-5 h-5 md:w-8 md:h-8 lg:w-7 lg:h-7 text-[#2F9D5E]"
                        />
                      ) : (
                        <div className="w-7 h-7 rounded-full bg-primary text-white flex justify-center items-center font-semibold text-sm">
                          {idx + 1}
                        </div>
                      )}
                    </div>
                    <div className="flex w-[calc(100%_-_40px)] justify-between items-center">
                      <div className="w-full  font-semibold text-left">{data.name}</div>
                      {isCompleted(data.step) ? (
                        <div className="md:w-40 flex justify-end">
                          <Link
                            to={isSubmitted ? "#" : `/consent-orders/initial-details?step=${data.step}`}
                            className={isSubmitted ? "pointer-events-none" : ""}
                          >
                            <button
                              className={classNames(
                                "w-fit uppercase font-bold text-right text-sm px-3 py-1 rounded-md hover:bg-primary/20 flex justify-center items-center space-x-2",
                                {
                                  "text-gray-300": isSubmitted,
                                  "text-primary": !isSubmitted
                                }
                              )}
                            >
                              <EditIcon
                                classes="w-3 h-3"
                                strokeColor={isSubmitted ? "text-gray-300" : "text-primary"}
                              />
                              <p className="tracking-wide">Edit</p>
                            </button>
                          </Link>
                        </div>
                      ) : isNext(data.step) ? (
                        <div className="md:w-40 flex justify-end">
                          <Link to={`/consent-orders/initial-details?step=${data.step}`}>
                            <button className="w-fit uppercase font-bold text-right text-sm text-primary px-3 py-1 rounded-md hover:bg-primary/20 flex justify-center items-center space-x-2">
                              <p className="tracking-wide">Continue</p>
                            </button>
                          </Link>
                        </div>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>
            ) : null}

            <button
              className="mt-6 pt-3 border-t w-full text-center text-primary font-semibold text-sm uppercase flex items-center justify-center space-x-2"
              onClick={() => toggleAccordion(0)}
            >
              <ChevronDownIcon
                strokeColor="text-primary"
                classes={classNames("w-4", {
                  "rotate-180": isOpen
                })}
              />
              <p>{isOpen ? "Show Less" : "Show More"}</p>
            </button>
          </div>
        );
      }
    },
    {
      icon: AddAssetsDebtsIcon,
      label: "PART 2",
      title: "Adding Assets and Debts",
      description:
        "Here you will account for the assets and debts of the relationship. We’ve made it easy and simple to add everything, and you will also have the chance to determine what you will do with each asset or debt.",
      link: "",
      showMore: true,
      showMoreContent: () => {
        const isSubmitted = consentOrders?.submitted ?? false;
        const isCompleted = (field: keyof AssetDebtFields) => consentOrders?.assetsDebts[field].isCompleted ?? false;
        const isNext = (step: number) => consentOrders?.assetsDebts?.currentStep === step;
        const isOpen = openAccordions[1];

        return (
          <div className="w-full mt-5 md:mt-0">
            {isOpen ? (
              <div className="space-y-5">
                {assetsDebtsRoutes.map((data, idx) => (
                  <div key={+idx} className="flex items-center justify-start bg-[#f2f2f2] rounded-lg p-3 md:p-5">
                    <div className="w-10">
                      {isCompleted(data.field) ? (
                        <CheckCircleIcon
                          strokeColor="text-[#2F9D5E]"
                          classes="w-5 h-5 md:w-8 md:h-8 lg:w-7 lg:h-7 text-[#2F9D5E]"
                        />
                      ) : (
                        <div className="w-7 h-7 rounded-full bg-primary text-white flex justify-center items-center font-semibold text-sm">
                          {idx + 1}
                        </div>
                      )}
                    </div>
                    <div className="w-[calc(100%_-_40px)] flex justify-between items-center">
                      <div className="w-full  font-semibold">{data.name}</div>
                      {isCompleted(data.field) ? (
                        <div className="md:w-40 flex justify-end">
                          <Link to={isSubmitted ? "#" : data.path} className={isSubmitted ? "pointer-events-none" : ""}>
                            <button
                              className={classNames(
                                "w-fit uppercase font-bold text-right text-sm px-3 py-1 rounded-md hover:bg-primary/20 flex justify-center items-center space-x-2",
                                {
                                  "text-gray-300": isSubmitted,
                                  "text-primary": !isSubmitted
                                }
                              )}
                            >
                              <EditIcon
                                classes="w-3 h-3"
                                strokeColor={isSubmitted ? "text-gray-300" : "text-primary"}
                              />
                              <p className="tracking-wide">Edit</p>
                            </button>
                          </Link>
                        </div>
                      ) : isNext(idx + 1) ? (
                        <div className="md:w-40 flex justify-end">
                          <Link to={data.path}>
                            <button className="w-fit uppercase font-bold text-right text-sm text-primary px-3 py-1 rounded-md hover:bg-primary/20 flex justify-center items-center space-x-2">
                              <p className="tracking-wide">Continue</p>
                            </button>
                          </Link>
                        </div>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
            <button
              className="mt-6 pt-3 border-t w-full text-center text-primary font-semibold text-sm uppercase flex items-center justify-center space-x-2"
              onClick={() => toggleAccordion(1)}
            >
              <ChevronDownIcon
                strokeColor="text-primary"
                classes={classNames("w-4", {
                  "rotate-180": isOpen
                })}
              />
              <p>{isOpen ? "Show Less" : "Show More"}</p>
            </button>
          </div>
        );
      }
    },
    {
      icon: FinalDetailsIcon,
      label: "PART 3",

      title: "Submit Information",
      description:
        "Here your provided information will be sent to our legal team for review. Our team will use this information to draft your consent order documents.",
      link: ""
    }
  ];
};

export const nextSteps = [
  {
    icon: LawyerConsultationIcon,
    title: "Speak with a family lawyer",
    description:
      "Our legal team will call you for a 30 min consultation about your situation, and gather any further information (if we need it). You can rest assured that you’re on the right track!",
    link: ""
  },
  {
    icon: ConsentOrderIcon,
    title: "Documents are prepared",
    description:
      "Our experienced family lawyers will draft your Consent Orders documents. No more wasting your time painfully trying to read through the many government websites. Get it done right the first time.",
    link: ""
  },
  {
    icon: DocumentSignIcon,
    title: "You sign & we lodge",
    description:
      "After your documents are completed, we’ll send it to you so you and your former partner can sign everything. After that. send it back, and we’ll lodge it with the courts for you! How easy is that?",
    link: ""
  }
];
